export default "__VITE_ASSET__s5o1USoV__"